import React from 'react';
import styled from 'styled-components';

interface IProps {
    marginRight: number;
}
export const RadioButton = styled.input<IProps>`
    margin-right: ${(props) => props.marginRight}px;
    appearance: none;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    background-color: white;
    border: 1px solid #003399;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:checked {
        background-color: #003399;
    }
`;
